import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { BINDINGS_MANAGEMENT_DISCLAIMER_TRANSLATION_KEYS as KEYS } from 'partner360/features/welcomeFlow/configs/translations'
import { useBindingManagementState } from 'partner360/features/welcomeFlow/ui/parts/bindingsManagementDisclaimer'

import styles from './MyPartnersDisclaimer.module.scss'

/** The Welcome Flow's bindings disclaimer as a section banner. It shares the wizard's "visited"
 *  flag, so a disclaimer acknowledged in either place opens collapsed in both. */
export const MyPartnersDisclaimer = () => {
  const { isDisclaimerExpanded, toggleDisclaimer } = useBindingManagementState()

  return (
    <InfoBlock
      type={InfoBlockType.Help}
      text={
        <div className={styles.content}>
          <div className={styles.title}>
            <Translation text={KEYS.title} />
          </div>

          {isDisclaimerExpanded && (
            <>
              <ul className={styles.list}>
                <Translation text={KEYS.bulletList} />
              </ul>
              <Translation text={KEYS.endMessage} />
            </>
          )}

          {/* The InfoBlock is the positioned box, so the toggle takes its top-right corner. */}
          <Button className={styles.toggle} variant="text" onClick={toggleDisclaimer}>
            <Translation span text={isDisclaimerExpanded ? KEYS.understood : KEYS.expand} />
          </Button>
        </div>
      }
    />
  )
}

MyPartnersDisclaimer.displayName = 'MyPartnersDisclaimer'
